import React, { useState, useEffect} from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


import * as serviceWorker from "./serviceWorker";

import './App.scss'

import ScrollToTop from "./helpers/ScrollToTop";

import Home from './components/Home';
import Article from './components/Article';
import Navigation from './components/Navigation';
import Info from './components/Info';
import Welcome from './components/Welcome';




const App = () => {


  const [isMenuActive, setIsMenuActive] = useState(false);
  
  const [isHomepage, setIsHomepage] = useState(false);

  const toggleMenuClass = () => {
    setIsMenuActive((prevIsMenuActive) => !prevIsMenuActive); 
  }



  return (

    <Router basename='/ebrochures/rathbones-review-winter-2023'>
    <HelmetProvider>
        <ScrollToTop />
        <div className={isMenuActive ? 'menu-active' : ''}>
          <Navigation toggleMenuClass={toggleMenuClass} isHomepage={isHomepage}/>
          <Routes>
            <Route path="/" element={<Home setIsHomepage={setIsHomepage} />} />
            <Route path="/welcome" element={<Welcome setIsHomepage={setIsHomepage} />} />
            <Route path="/:page?" element={<Article setIsHomepage={setIsHomepage} />} />
            <Route path="/additional-information" element={<Info setIsHomepage={setIsHomepage} />} />
          </Routes>
        </div>
      </HelmetProvider>
    </Router>
  );
};


export default App;

